module.exports = __webpack_public_path__ + "static/media/ic_video_deactivate.c7b5cc02.svg";